import React, { useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link, Switch, Route, Redirect } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import ProductCta from '../../components/ProductCta/ProductCta';
import ProductCtaBar from '../../components/ProductCta/ProductCtaBar';
import MotorQuoteForm from './komunikacyjne/MotorQuoteForm';
import CallbackCTA from './komunikacyjne/CallbackCTA';
import './komunikacyjne/komunikacyjne.scss';

// Treść i układ 1:1 ze stroną publiczną uspartner.pl/ubezpieczenia/komunikacyjne
// (usppublicsite: src/content/insurance/komunikacyjne.ts + page.tsx).
const RECAPTCHA_KEY = '6LfwmGMhAAAAAK4YxJ0Kdx3dASJum_bvYSWUE_jJ';
const LOGO_BASE = '/tvp/komunikacyjne';
const HERO_IMAGE = '/tvp/dashboard/83.jpg';
export const FORM_PATH = '/komunikacyjne/opis/#formularz';

const CONTENT = {
  hero: {
    eyebrow: 'OC · AC · Assistance · NNW',
    title: 'Ubezpieczenie Twojego Auta — Pakiety Dealerskie',
    lede: 'Wynegocjowane pakiety sześciu towarzystw dla aut osobowych, dostawczych do 3,5 t DMC i kamperów — nowych i używanych, także finansowanych w leasingu lub kredycie. Wyślij zapytanie, a porównamy oferty i przygotujemy propozycję.',
    imageAlt: 'Niebieski samochód osobowy w ruchu na drodze'
  },
  insurersLabel: 'Pakiety w ofercie',
  insurers: [
    { name: 'PZU', src: `${LOGO_BASE}/pzu.svg`, scale: 1.12 },
    { name: 'Allianz', src: `${LOGO_BASE}/allianz.svg` },
    { name: 'Generali', src: `${LOGO_BASE}/generali.svg` },
    { name: 'Ergo Hestia', src: `${LOGO_BASE}/ergo-hestia.svg` },
    { name: 'InterRisk', src: `${LOGO_BASE}/interrisk.svg`, scale: 1.45 },
    { name: 'Uniqa', src: `${LOGO_BASE}/uniqa.svg`, scale: 1.1 }
  ],
  audienceHeading: 'Dla kogo?',
  audience: [
    {
      title: 'Osoby prywatne',
      desc: 'Polisa OC i AC dla samochodu prywatnego — z assistance i NNW w pakiecie.'
    },
    {
      title: 'Firmy',
      desc: 'Działalności gospodarcze i spółki — pojazdy firmowe, dostawcze i auta w leasingu.'
    },
    {
      title: 'Pojazdy',
      desc: 'Osobowe, ciężarowe do 3,5 t DMC oraz kempingowe — kampery i przyczepy kempingowe.'
    }
  ],
  audienceNote:
    'Pakiety zostały wynegocjowane dla pojazdów nowych i używanych — głównie do 6. roku eksploatacji — w tym finansowanych w leasingu lub kredycie.',
  packagesHeading: 'Sześć pakietów, sześć towarzystw',
  packagesIntro:
    'Każdy pakiet ma inną mocną stronę. Porównamy je dla Twojego auta i wskażemy ten, który daje najlepszy zakres w rozsądnej cenie.',
  packages: [
    {
      insurer: 'PZU',
      name: 'Pakiet PZU',
      desc: 'Stała suma ubezpieczenia oraz brak redukcji sumy ubezpieczenia w cenie — dla pojazdów do 5. roku eksploatacji.'
    },
    {
      insurer: 'Allianz',
      name: 'Pakiet Allianz',
      desc: 'Konkurencyjne składki dla prestiżowych marek.'
    },
    {
      insurer: 'Generali',
      name: 'Pakiet Generali',
      desc: 'Assistance bez ograniczenia kilometrów dla pojazdów osobowych.'
    },
    {
      insurer: 'Ergo Hestia',
      name: 'Pakiet Ergo Hestia',
      desc: 'Brak redukcji sumy ubezpieczenia w standardzie oraz stała suma ubezpieczenia już od 100 zł.'
    },
    {
      insurer: 'InterRisk',
      name: 'InterRisk Premium+',
      desc: 'Assistance Premium oraz szyby na częściach oryginalnych w zakresie.'
    },
    {
      insurer: 'Uniqa',
      name: 'Uniqa Pakiet Leasing',
      desc: 'Wyłącznie dla aut finansowanych w ramach leasingu, kredytu lub wynajmu długoterminowego.'
    }
  ],
  stepsHeading: 'Jak to działa?',
  steps: [
    {
      title: 'Wysyłasz zapytanie',
      desc: 'Podajesz dane auta, zakres ochrony i kontakt w formularzu poniżej.'
    },
    {
      title: 'Porównujemy pakiety',
      desc: 'Sprawdzamy oferty sześciu towarzystw dla Twojego pojazdu i sposobu finansowania.'
    },
    {
      title: 'Dostajesz propozycję',
      desc: 'Wracamy do Ciebie z zakresem, składką i naszą rekomendacją.'
    },
    {
      title: 'Wystawiamy polisę',
      desc: 'Potrzebne będą dane z dowodu rejestracyjnego, przy AC ewentualnie zdjęcia pojazdu oraz krótka analiza potrzeb (APK).'
    }
  ],
  callback: {
    teaser: 'Nie chcesz wypełniać formularza?',
    teaserLink: 'Zostaw numer — oddzwonimy',
    title: 'Nie chcesz wypełniać formularza? Oddzwonimy.',
    lede: 'Zostaw imię i numer — doradca zadzwoni, zbierze dane o aucie przez telefon i przygotuje ofertę. Bez zobowiązań.',
    topic: 'Ubezpieczenie Twojego Auta — Pakiety Dealerskie'
  },
  formHeading: 'Zapytanie o ofertę',
  formLede:
    'Wypełnij formularz — im dokładniejsze dane, tym szybciej przygotujemy porównanie. Pola oznaczone gwiazdką są wymagane.',
  disclaimer:
    'Informacje na tej stronie mają charakter wyłącznie informacyjny i nie stanowią oferty w rozumieniu art. 66 kodeksu cywilnego. Wysokość składki oraz zakres ochrony zależą od danych pojazdu i kierowców, wybranego wariantu i ogólnych warunków ubezpieczenia danego towarzystwa. Ochrona ubezpieczeniowa obowiązuje od daty wskazanej w polisie.'
};

// Nawigacja z react-routera nie przewija do kotwicy — robimy to sami.
const ANCHOR_OFFSET = 84; // = scroll-margin-top kotwic w komunikacyjne.scss

const scrollToHash = (hash, behavior = 'smooth') => {
  if (!hash) return;
  const el = document.getElementById(hash.replace('#', ''));
  if (el) {
    el.scrollIntoView({ behavior, block: 'start' });
  }
};

// Po dociągnięciu obrazków i fontów układ się przesuwa — dociągamy cel,
// jeśli odjechał od górnej krawędzi (bez animacji, żeby nie skakać).
const settleHash = (hash) => {
  if (!hash) return;
  const el = document.getElementById(hash.replace('#', ''));
  if (!el) return;
  const top = el.getBoundingClientRect().top;
  if (Math.abs(top - ANCHOR_OFFSET) > 4) {
    el.scrollIntoView({ behavior: 'auto', block: 'start' });
  }
};

const AnchorLink = ({ hash, className, children }) => (
  <a
    href={`#${hash}`}
    className={className}
    data-product-cta
    onClick={(e) => {
      e.preventDefault();
      scrollToHash(hash);
    }}
  >
    {children}
  </a>
);

const Opis = ({ location }) => {
  useEffect(() => {
    // Obrazek hero i fonty dociągają się po renderze i przesuwają układ,
    // więc przewijamy kilka razy, aż strona się ustabilizuje.
    const first = setTimeout(() => scrollToHash(location.hash), 0);
    const settlers = [400, 900, 1500, 2400].map((ms) =>
      setTimeout(() => settleHash(location.hash), ms)
    );
    return () => [first, ...settlers].forEach(clearTimeout);
  }, [location.hash]);

  return (
    <>
      <section className="k-hero">
        <div className="k-hero-bg" aria-hidden />
        <div className="k-hero-in">
          <div className="k-hero-text">
            <span className="k-eyebrow on-dark">{CONTENT.hero.eyebrow}</span>
            <h1 className="k-hero-title">{CONTENT.hero.title}</h1>
            <p className="k-hero-lede">{CONTENT.hero.lede}</p>
            <div className="k-hero-ctas">
              <AnchorLink hash="formularz" className="k-btn k-btn-light">
                Wyślij zapytanie
                <span className="k-arrow" aria-hidden>
                  →
                </span>
              </AnchorLink>
              <AnchorLink hash="pakiety" className="k-btn k-btn-teal">
                Zobacz pakiety
              </AnchorLink>
            </div>
            <p className="k-hero-note">
              {CONTENT.callback.teaser}{' '}
              <a
                href="#oddzwonimy"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToHash('oddzwonimy');
                }}
              >
                {CONTENT.callback.teaserLink} →
              </a>
            </p>
          </div>
          <div className="k-hero-media">
            <img
              className="k-hero-photo"
              src={HERO_IMAGE}
              alt={CONTENT.hero.imageAlt}
            />
          </div>
        </div>
      </section>

      <div className="k-insurers">
        <p className="k-insurers-label">{CONTENT.insurersLabel}</p>
        <ul className="k-insurers-list" aria-label={CONTENT.insurersLabel}>
          {CONTENT.insurers.map((i) => (
            <li key={i.name} className="k-insurers-item">
              <img
                src={i.src}
                alt={i.name}
                className="k-insurers-logo"
                style={i.scale ? { '--logo-scale': i.scale } : undefined}
              />
            </li>
          ))}
        </ul>
      </div>

      <section className="k-section k-section-offer k-section-tight">
        <h2>{CONTENT.audienceHeading}</h2>
        <div className="k-cards">
          {CONTENT.audience.map((card) => (
            <div key={card.title} className="k-card">
              <h3>{card.title}</h3>
              <p>{card.desc}</p>
            </div>
          ))}
        </div>
        <p className="k-audience-note">{CONTENT.audienceNote}</p>
      </section>

      <section
        className="k-section k-section-offer k-section-tight"
        id="pakiety"
      >
        <h2>{CONTENT.packagesHeading}</h2>
        <p className="k-lead">{CONTENT.packagesIntro}</p>
        <div className="k-packages">
          {CONTENT.packages.map((pkg) => (
            <div key={pkg.name} className="k-pkg">
              <span className="k-pkg-insurer">{pkg.insurer}</span>
              <h3>{pkg.name}</h3>
              <p>{pkg.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="k-section k-section-offer k-section-tight">
        <h2>{CONTENT.stepsHeading}</h2>
        <ol className="k-steps">
          {CONTENT.steps.map((step) => (
            <li key={step.title}>
              <span>
                <strong>{step.title}</strong> — {step.desc}
              </span>
            </li>
          ))}
        </ol>
      </section>

      <section className="k-section k-form-sec" id="formularz">
        <div className="k-section-head">
          <h2>{CONTENT.formHeading}</h2>
          <p className="k-lede">{CONTENT.formLede}</p>
          <p className="k-callback-teaser">
            {CONTENT.callback.teaser}{' '}
            <a
              href="#oddzwonimy"
              onClick={(e) => {
                e.preventDefault();
                scrollToHash('oddzwonimy');
              }}
            >
              {CONTENT.callback.teaserLink} →
            </a>
          </p>
        </div>
        <MotorQuoteForm />
        <p className="k-disclaimer">{CONTENT.disclaimer}</p>
      </section>

      <CallbackCTA
        title={CONTENT.callback.title}
        lede={CONTENT.callback.lede}
        topic={CONTENT.callback.topic}
      />
    </>
  );
};

const Komunikacyjne = (props) => {
  const basePath = props.match.path;

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
      <div className="komunikacyjne-shell">
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">{props.rootSection}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to={basePath}>{props.section}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>Opis</BreadcrumbItem>
        </Breadcrumb>

        <Switch>
          <Route path={`${basePath}opis/`} component={Opis} />
          <Redirect from={`${basePath}public`} to={FORM_PATH} />
          <Redirect from={`${basePath}kup`} to={FORM_PATH} />
          <Redirect from={basePath} to={`${basePath}opis/`} />
        </Switch>

        <ProductCtaBar title="Ubezpieczenie Twojego Auta — Pakiety Dealerskie">
          <ProductCta to={FORM_PATH}>Zapytaj o ofertę</ProductCta>
        </ProductCtaBar>
      </div>
    </GoogleReCaptchaProvider>
  );
};

export default Komunikacyjne;
